import { FontStyle } from '@react-pdf/font';
import { Document, Font } from '@react-pdf/renderer';
import { COMPONENTS } from '~/utils/components';
import { parseJson, renderComponent } from '~/utils/helpers';

export const PdfGenerator: React.FC<{ data: string; template: string }> = ({
  data,
  template,
}) => {
  const templateObject = parseJson(template);
  const dataObject = parseJson(data);

  const fonts = templateObject?.fonts || [];
  fonts.forEach(
    (font: {
      family: string;
      fonts: { src: string; fontWeight?: number; fontStyle?: FontStyle }[];
    }) => {
      Font.register(font);
    },
  );

  const componentData = templateObject?.components || [];
  const images = templateObject?.images || {};

  const renderedComponents = renderComponent({
    componentData,
    components: COMPONENTS,
    data: dataObject || {},
    allProps: {},
    images,
  });

  return <Document>{renderedComponents}</Document>;
};
